import React, { useState } from 'react';

const NewInspection = ({ onStartInspection }) => {
  const [formData, setFormData] = useState({
    streetNumber: '',
    streetName: '',
    city: '',
    state: '',
    zip: '',
    parcelNumber: '',
    totalUnits: '',
    bedrooms: '',
    bathrooms: '',
    inspectionType: 'health_safety',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onStartInspection(formData);
  };

  return (
    <div className="container">
      <h2>New Inspection</h2>
      <form onSubmit={handleSubmit}>
        <div>
          <label>Street Number:</label>
          <input
            type="text"
            name="streetNumber"
            value={formData.streetNumber}
            onChange={handleChange}
            required
          />
        </div>
        <div>
          <label>Street Name:</label>
          <input
            type="text"
            name="streetName"
            value={formData.streetName}
            onChange={handleChange}
            required
          />
        </div>
        <div>
          <label>City:</label>
          <input
            type="text"
            name="city"
            value={formData.city}
            onChange={handleChange}
            required
          />
        </div>
        <div>
          <label>State:</label>
          <input
            type="text"
            name="state"
            value={formData.state}
            onChange={handleChange}
            required
          />
        </div>
        <div>
          <label>Zip:</label>
          <input
            type="text"
            name="zip"
            value={formData.zip}
            onChange={handleChange}
            required
          />
        </div>
        <div>
          <label>Parcel Number:</label>
          <input
            type="text"
            name="parcelNumber"
            value={formData.parcelNumber}
            onChange={handleChange}
          />
        </div>
        <div>
          <label>Total Units:</label>
          <input
            type="number"
            name="totalUnits"
            value={formData.totalUnits}
            onChange={handleChange}
          />
        </div>
        <div>
          <label>Bedrooms:</label>
          <input
            type="number"
            name="bedrooms"
            value={formData.bedrooms}
            onChange={handleChange}
          />
        </div>
        <div>
          <label>Bathrooms:</label>
          <input
            type="number"
            name="bathrooms"
            value={formData.bathrooms}
            onChange={handleChange}
          />
        </div>
        <div>
          <label>Inspection Type:</label>
          <select
            name="inspectionType"
            value={formData.inspectionType}
            onChange={handleChange}
          >
            <option value="health_safety">Health & Safety</option>
            <option value="ipmc">IPMC</option>
          </select>
        </div>
        <button type="submit">Start Inspection</button>
      </form>
    </div>
  );
};

export default NewInspection;
